import { Injectable, signal, computed } from '@angular/core';

@Injectable()
export class LoadingIndicatorService {

  private readonly openConnections = signal(0);

  public readonly isLoading = computed(() => this.openConnections() > 0);

  public newConnection(): void {
    this.openConnections.update(count => count + 1);
  }

  public connectionClosed(): void {
    this.openConnections.update(count => Math.max(0, count - 1));
  }

}
